export default __webpack_public_path__ + "img/autocomplete-icons.png";